import { AlertProductRecalculationRequired } from "./AlertProductRecalculationRequired";
import { useContext, useState } from "react";
import { ProjectContext } from "./ProjectProvider";
import { AlternativeContext } from "./quote/alternative/AlternativeContext";
import { useProjectId } from "./shopdrawing/ProjectName";
import { useAlternative } from "./quote/alternative/Alternative";
import { useLocalStorage } from "../../misc/LocalSession";
import { useEventEmitter } from "../../misc/UseEventEmitter";
import { Menu, MenuItem } from "@mui/material";
import { useReloader } from "./shopdrawing/hardware/ReloadContext";
import CalculateIcon from '@mui/icons-material/Calculate';
import { HeaderActionButton } from "./shopdrawing/HeaderActionButton";
import { grey } from "@mui/material/colors";
import { HistoryDialog } from "./prodrecalc/HistoryDialog";
import { DynamicErrorsDialog } from "./prodrecalc/DynamicErrorsDialog";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function useAlertProductRecalcState() {
    const projCtx = useContext(ProjectContext);
    const altCtx = useContext(AlternativeContext);
    const hwReload = useReloader();
    const projectId = useProjectId();
    const altId = useAlternative();
    const [hide, setHide] = useLocalStorage(`product-recalc-proj=${projectId}-alt=${altId}`, false);
    const alt = useEventEmitter(altCtx.alternative);
    let show = false;
    if (altCtx.valid) {
        show = (alt === null || alt === void 0 ? void 0 : alt.needsRecalculateProducts) || false;
    }
    else if (projCtx.valid) {
        show = projCtx.value.needsRecalculateProducts;
    } // also include dynamic in the error set
    const hasDynamicErr = projCtx.valid && projCtx.value.hasDynamicProductErrors;
    let loading = false;
    if (!projCtx.value)
        loading = true;
    if (altCtx.valid && !alt)
        loading = true;
    const onDone = () => { setHide({ value: true, expiresAt: Date.now() + 5 * 1000 }); projCtx.reload(); hwReload.current(); if (altCtx.valid) {
        altCtx.reload();
    } };
    const onHide = () => {
        setHide({ value: true, expiresAt: Date.now() + 5 * 60 * 1000 // 5 minutes
        });
    };
    return { loading, show, hasDynamicErr, hide, onHide, onUnHide: () => setHide(null), projectId, altId, onDone };
}
export function AlertProductRecalcHeader() { const [showMenu, setShowMenu] = useState(null); const [showHistory, setShowHistory] = useState(false); const [showDynamicErrors, setShowDynamicErrors] = useState(false); const { show, hide, hasDynamicErr, projectId, altId, onHide, onUnHide, onDone, loading } = useAlertProductRecalcState(); if (loading)
    return null; return /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx(HeaderActionButton, { label: "Products", icon: /*#__PURE__*/ _jsx(CalculateIcon, { fontSize: "inherit", color: grey["800"] }), badgeContent: show || hasDynamicErr ? "Errors" : null, onClick: e => { setShowMenu(e.currentTarget); } }), showMenu && /*#__PURE__*/ _jsxs(Menu, { onClose: () => setShowMenu(null), open: true, anchorEl: showMenu, children: [show && /*#__PURE__*/ _jsx(MenuItem, { onClick: () => { setShowMenu(null); onUnHide(); }, children: "Fix Errors" }), /*#__PURE__*/ _jsx(MenuItem, { onClick: () => { setShowMenu(null); setShowHistory(true); }, children: "Product Change History" }), /*#__PURE__*/ _jsx(MenuItem, { onClick: () => { setShowMenu(null); setShowDynamicErrors(true); }, children: "Dynamic Errors" })] }), showHistory && /*#__PURE__*/ _jsx(HistoryDialog, { onClose: () => setShowHistory(false) }), showDynamicErrors && /*#__PURE__*/ _jsx(DynamicErrorsDialog, { onClose: () => setShowDynamicErrors(false) }), !hide && show && /*#__PURE__*/ _jsx(AlertProductRecalculationRequired, { project: projectId, alternative: altId, onHide: onHide, onDone: onDone })] }); }
